// client/customer/src/utils/reservation/by-Date/fetchStoresForReserve.ts
import apiConfig from '../../../apiConfig';

export type ReserveStore = {
  id: number;
  name: string;
  location: string | null;
  telegram_url?: string | null;
  instagram_url?: string | null;
  tiktok_url?: string | null;
  messenger_url?: string | null;
};

export const fetchStoresForReserve = async (): Promise<ReserveStore[]> => {
  const res = await fetch(
    `${apiConfig.baseURL}/api/customer-app/reservation/by-date/stores`,
  );

  if (!res.ok) {
    throw new Error('Failed to fetch stores');
  }

  const data = (await res.json()) as ReserveStore[];
  return data;
};
